<template>
  <div id="app">
    <div class="app-wrap">
      <router-view/>
    </div>
  </div>
</template>

<script>
export default {
  components: {

  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap');

  html {
    position: relative;
    min-height: 100%;
    overflow-x: auto;
  }

  body {
    overflow-x: auto;
    min-height: 100%;
    background-color: white;
    position: relative;
  }

  #app, .home-container, .box {
    position: relative;
    min-height: 100vh;
  }

  .app-wrap {
    position: relative;
    min-height: 100vh;
    padding-bottom: 0;
    margin-bottom: 0;
  }
</style>
